import AccountChart from './AccountChart';

export default AccountChart;
